'use strict';
var Bucket = require('../data/bucket');
module.exports = function (tile, pixelValue, z) {
    return pixelValue * (Bucket.EXTENT / (tile.tileSize * Math.pow(2, z - tile.coord.z)));
};